<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: lixianbing
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2022-03-01 11:26:22
 -->
<template>
  <div class="loading">
    <div class="box">
      <el-form
        :model="box"
        :rules="rules"
        ref="ruleForm"
        status-icon
        label-position="left"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="username">
          <el-input placeholder="请输入用户名" v-model="box.username"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input placeholder="请输入联系人" v-model="box.contacts"></el-input>
        </el-form-item>
        <el-form-item label="联系人手机号" prop="contactsTel">
          <el-input
            placeholder="请输入11位数电话号码"
            v-model="box.contactsTel"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input placeholder="请输入邮箱" v-model="box.email"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="capcha">
          <el-input placeholder="请输入验证码" v-model="box.capcha">
            <template slot="append">
              <div style="cursor: pointer" v-show="show" @click="getCodes">
                获取验证码
              </div>
              <div v-show="!show" class="count">{{ count }} s后重发</div>
            </template>
          </el-input>
          <p v-show="timeshow">验证码已发送到注册邮箱，请注意查收，验证码5分钟内有效</p>
        </el-form-item>
        <el-form-item label="密码" prop="password" style="margin-bottom: 35px">
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="box.password"
            show-password
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="请确认密码" prop="sureword">
          <el-input
            type="password"
            placeholder="请再次输入密码"
            v-model="box.sureword"
            show-password
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="所在行业" prop="business">
          <el-select v-model="box.business" placeholder="请选择">
            <el-option
              v-for="item in businesoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区" prop="regionId">
          <el-select v-model="box.regionId" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.regionCode"
              :label="item.regionName"
              :value="item.regionCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div id="btns">
        <el-checkbox v-model="checked">请填写真实信息，方便审核人员核查信息</el-checkbox>
        <div class="btn" @click="submint('ruleForm')">注册</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode, getregion, register } from "@/api/file";
import utils from "@/plugins/utils";
import cookies from "@/plugins/utils/cookies";
import resetPwd from "@/mixins/resetPwd";
export default {
  components: {},
  mixins:[resetPwd],
  data() {
    var surewordPss = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入确认密码"));
      } else {
        if (this.box.sureword !== this.box.password) {
          callback(new Error("两次输入密码不一致"));
        } else {
          callback();
        }
      }
    };
    return {
      fieldName: {
        value: "regionCode",
        label: "regionName",
        children: "children",
      },
      checked: true,
      businesoptions: [
        {
          value: "1",
          label: "旅游机构",
        },
        {
          value: "2",
          label: "文化公司",
        },
        {
          value: "3",
          label: "文化艺术类协会",
        },
        {
          value: "4",
          label: "合唱团",
        },
        {
          value: "5",
          label: "学校/少年宫",
        },
        {
          value: "6",
          label: "指挥/教师/个人合唱爱好者",
        },
        {
          value: "7",
          label: "其他行业",
        },
      ],
      options: [],
      value: "",
      name: "",
      show: true,
      count: "",
      timer: null,
      regionId: "",
      toastText: "",
      box: {
        username: "",
        contacts: "",
        password: "",
        email: "",
        contactsTel: "",
        regionId: "",
        business: "",
        capcha: "",
        sureword: "",
      },
      timeshow: false,
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        contacts: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   validator: (rule, value, callback) => {
          //     var reg = /^[a-zA-Z]{1}.*(?=.{11,19})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
          //     if (!reg.test(value)) {
          //       callback(
          //         new Error(
          //           "密码格式:必须字母开头，长度是12-20位，且包含特殊字符、数字、大小写字母;如(W1234567@1aA)"
          //         )
          //       );
          //     }
          //     callback();
          //   },
          //   trigger: "blur",
          // },
        ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        contactsTel: [{ required: true, message: "请输入联系人电话", trigger: "blur" }],
        capcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        business: [{ required: true, message: "请选择所在行业", trigger: "blur" }],
        regionId: [{ required: true, message: "请选择地区", trigger: "blur" }],
        sureword: [{ required: true, validator: surewordPss, trigger: "blur" }],
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getregiontree();
  },
  methods: {
    handleChange(value) {
      console.log(value);
    },
    //邮箱获取验证码
    getCodes() {
      getCode(this.box.email).then((res) => {
        if (res.code == 200) {
          this.$message.success("验证码已发送邮箱");
          this.timeshow = true;
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    //获取地区
    getregiontree() {
      let data = {};
      getregion(data).then((res) => {
        if (res.code == 200) {
          this.options = res.data;
        } else {
          this.$message.success("获取地区失败");
        }
      });
    },
    submint(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            username: this.box.username,
            contacts: this.box.contacts,
            password: this.fromatPassword(this.box.password),
            email: this.box.email,
            contactsTel: this.box.contactsTel,
            business: this.box.business,
            regionId: this.box.regionId.toString(),
            capcha: this.box.capcha,
          };
          register(data).then((res) => {
            if (res.code == 200) {
              this.$message.success("注册成功");
              this.$router.push("/login");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped="" lang="scss">
* {
  padding: 0;
  margin: 0;
}

.loading {
  width: 100%;
  background: #29557b;
  height: 100%;
}

.box {
  height: 100%;
  margin: auto;
  width: 40%;
  background: white;
  min-width: 600px;
}
.box .el-form {
  padding-top: 50px;
  padding-left: 100px;
  padding-right: 120px;
}
.box ul {
  padding-left: 120px;
  padding-right: 120px;
  margin: auto;
}

.box ul > li {
  display: flex;
  margin-top: 14px;
  width: 80%;
}

.box ul > li p {
}

.box ul > li > div {
  width: 100%;

  /deep/.el-input {
    .el-input-group__append {
      background: #167afc;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      opacity: 0.5;
    }
  }
}

.box ul > li div > label {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3c4353;
  line-height: 34px;
}

.box ul > li div > label span {
  color: #fc524c;
}

.box ul > li div > .el-input {
  min-width: 100%;
}

.box ul > li p {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #24558b;
  line-height: 34px;
}

.btn {
  width: 100%;
  height: 60px;
  background: #24558b;
  opacity: 0.5;
  border-radius: 4px;
  text-align: center;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 60px;
  cursor: pointer;
  margin-top: 10px;
}

.updata {
  justify-content: flex-end;
}
.el-form-item {
  margin-bottom: 22px;
}
#btns {
  width: 50%;
  margin: auto;
}
.el-input {
  min-width: 200px;
}
.el-select {
  min-width: 200px;
}
</style>
